<template>
  <div>
    <v-app-bar
      app
      flat
      color="main"
      dark
      height="64"
      style="z-index: 11;"
    >
      <v-sheet
        color="transparent"
        class="
          d-flex flex-column
          col-12 pa-0
        "
      >
        <section
          class="
            d-flex align-center
          "
          style="gap: 16px;"
        >
          <router-link :to="computedHomeRoute">
            <v-btn link text class="px-0">
              <v-img
                alt="UCPA"
                class="shrink"
                src="/assets/ucpa.svg"
                width="100"
              />
            </v-btn>
          </router-link>
          <v-chip
            light
            small
            class="text-uppercase"
            :href="appUrl"
            target="_blank"
          >
            Talent
          </v-chip>

          <v-spacer />

          <v-autocomplete
            v-model="activeWorkspaceAux"
            :items="workspaces.filter(w => w.code)"
            hide-details
            item-text="name"
            item-value="code"
            :filter="customFilter"
            label="Rechercher un Workspace"
            class="d-none d-sm-block"
            outlined
            dense
            style="max-width: 350px;"
            :style="{ userSelect: 'none', WebkitUserSelect: 'none' }"
            @input="updateWorkspace"
            @keydown.escape="activeWorkspaceAux = activeWorkspace"
            @blur="activeWorkspaceAux = activeWorkspace"
            @contextmenu.prevent
          >
            <template #item="{ item }">
              <div :class="activeWorkspaceAux === item.code ? 'primary--text v-list-item--active v-list-item--highlighted' : ''">
                {{ item.name }}
              </div>
            </template>
          </v-autocomplete>

          <v-spacer />

          <template v-if="activeWorkspace">
            <!-- Desktop Actions -->
            <DesktopHeaderActions
              class="d-none d-sm-flex"
              :user="user"
              :active-workspace="activeWorkspace"
              :can-perform-action="canPerformAction"
            />

            <!-- Mobile Actions -->
            <MobileHeaderActions
              class="d-block d-sm-none"
              :user="user"
              :active-workspace="activeWorkspace"
              :can-perform-action="canPerformAction"
              @open-workspace-search="workspaceDialog = true"
            />
          </template>
        </section>
      </v-sheet>
    </v-app-bar>
    <!-- Mobile Workspace Search Dialog -->
    <v-dialog
      v-model="workspaceDialog"
      hide-overlay
      fullscreen
      transition="dialog-top-transition"
    >
      <v-card
        class="d-flex flex-column"
      >
        <v-toolbar height="64" max-height="64" dark color="main">
          <v-btn icon dark @click="workspaceDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Changer de workspace</v-toolbar-title>
        </v-toolbar>
        <v-card
          elevation="0"
          color="transparent"
          class="flex-grow-1 d-flex flex-column justify-space-between"
        >
          <v-card-text class="pt-6">
            <v-autocomplete
              v-model="activeWorkspaceAux"
              :items="workspaces.filter(w => w.code)"
              hide-details
              item-text="name"
              item-value="code"
              :filter="customFilter"
              label="Rechercher un Workspace"
              outlined
              dense
              autofocus
              :style="{ userSelect: 'none', WebkitUserSelect: 'none' }"
              @input="handleMobileWorkspaceUpdate"
              @contextmenu.prevent
            >
              <template #item="{ item }">
                <div :class="activeWorkspaceAux === item.code ? 'primary--text v-list-item--active v-list-item--highlighted' : ''">
                  {{ item.name }}
                </div>
              </template>
            </v-autocomplete>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              class="col-12"
              @click="workspaceDialog = false"
            >
              <v-icon>mdi-close</v-icon>
              Fermer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import DesktopHeaderActions from './DesktopHeaderActions.vue';
import MobileHeaderActions from './MobileHeaderActions.vue';

export default {
  name: 'Header',
  components: { DesktopHeaderActions, MobileHeaderActions },
  props: {
    appUrl: {
      type: String,
      default: null
    },
    user: {
      type: Object,
      default: () => ({})
    },
    activeWorkspace: {
      type: String,
      default: null
    },
    workspaces: {
      type: Array,
      default: () => []
    },
    activeBrand: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      activeWorkspaceAux: this.activeWorkspace,
      workspaceDialog: false
    };
  },
  computed: {
    ...mapGetters(['canPerformAction']),
    computedHomeRoute () {
      if (this.activeWorkspace === 'spontaneous') {
        return { name: 'candidature-spontanee-list' };
      }

      if (this.$store.getters.isCentralizedWorkspace) {
        return { name: 'model-offers-list' };
      }

      return { name: 'home' };
    }
  },
  watch: {
    activeWorkspace (value) {
      this.activeWorkspaceAux = value;
    }
  },
  methods: {
    customFilter (item, queryText, itemText) {
      const normalizeString = str => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
      return normalizeString(itemText).indexOf(normalizeString(queryText)) > -1;
    },
    updateWorkspace (value) {
      if (!value || value === this.activeWorkspace) {
        return;
      }
      this.$emit('update-workspace', value);
    },

    handleMobileWorkspaceUpdate (value) {
      if (!value || value === this.activeWorkspace) {
        this.activeWorkspaceAux = this.activeWorkspace;
        return;
      }

      this.updateWorkspace(value);
      this.workspaceDialog = false; // Close dialog on selection
    }
  }
};
</script>
